import { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import axios from 'axios';
import { theme, buttonStyles, modalStyles, typography, spacing, mergeStyles } from '../styles/theme';
import { trackUserEvent } from '../analytics';

// Initialize Stripe with your publishable key
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

export default function UpgradeToPremium({ user, onClose, autoOpen = false }) {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(autoOpen);
  const [error, setError] = useState('');

  const handleUpgrade = async () => {
    trackUserEvent('upgrade_to_premium_clicked');
    setLoading(true);
    setError('');

    try {
      // Get Firebase token
      const token = await user.getIdToken();

      // Call backend to create Stripe checkout session
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/create-checkout-session`,
        {},
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      // Redirect to Stripe Checkout
      const stripe = await stripePromise;
      window.location.href = response.data.url;

    } catch (error) {
      console.error('Error creating checkout session:', error);
      setError('Failed to start checkout. Please try again.');
      setLoading(false);
    }
  };

  const handleClose = () => {
    setShowModal(false);
    if (onClose) onClose();
  };

  return (
    <>
      {/* Upgrade button - only show if NOT auto-opening */}
      {!autoOpen && (
        <button
          onClick={() => setShowModal(true)}
          style={mergeStyles(
            buttonStyles.base,
            buttonStyles.primary,
            buttonStyles.small,
            {
              display: 'inline-flex',
              alignItems: 'center',
              gap: spacing.xs,
            }
          )}
        >
          <img
            src="/premium-badge.svg"
            alt=""
            style={{ height: '16px', width: '16px' }}
          />
          Upgrade to Premium
        </button>
      )}
      {/* Confirmation modal */}
      {showModal && (
        <div style={modalStyles.overlay} onClick={handleClose}>
          <div
            onClick={(e) => e.stopPropagation()}
            style={modalStyles.content}
          >
            <button onClick={handleClose} style={modalStyles.closeButton}>
              ×
            </button>

            <h2 style={{
              marginTop: 0,
              color: theme.text.primary,
              fontFamily: typography.fontFamily.primary,
              fontSize: typography.fontSize['2xl'],
              display: 'flex',
              alignItems: 'center',
              gap: spacing.sm,
            }}>
              <img
                src="/premium-badge.svg"
                alt=""
                style={{ height: '28px', width: '28px' }}
              />
              Upgrade to Premium
            </h2>

            <div style={{
              backgroundColor: theme.bg.secondary,
              padding: spacing.xl,
              borderRadius: '8px',
              marginBottom: spacing.xl
            }}>
              <h3 style={{
                marginTop: 0,
                color: theme.brand.primary,
                fontSize: typography.fontSize.xl
              }}>
                $5.00 / month
              </h3>

              <ul style={{
                listStyle: 'none',
                padding: 0,
                margin: 0,
                color: theme.text.primary
              }}>
                <li style={{ marginBottom: spacing.md }}>
                  ✓ Access to GPT-4.1 mini (better, more accurate answers)
                </li>
                <li style={{ marginBottom: spacing.md }}>
                  ✓ Priority support
                </li>
                <li style={{ marginBottom: spacing.md }}>
                  ✓ Conversation history and saved chats
                </li>
                <li style={{ marginBottom: spacing.md }}>
                  ✓ Faster response times
                </li>
                <li style={{ marginBottom: spacing.md }}>
                  ✓ Search and favorites
                </li>
                <li style={{ marginBottom: spacing.md }}>
                  ✓ Export to PDF
                </li>
                <li>
                  ✓ Support Judgy's development
                </li>
              </ul>
            </div>

            {error && (
              <p style={{
                color: theme.status.error,
                backgroundColor: '#FFE5E5',
                padding: spacing.md,
                borderRadius: '6px',
                fontSize: typography.fontSize.sm,
                marginBottom: spacing.lg
              }}>
                {error}
              </p>
            )}

            <div style={{ display: 'flex', gap: spacing.md }}>
              <button
                onClick={handleClose}
                disabled={loading}
                style={mergeStyles(
                  buttonStyles.base,
                  buttonStyles.secondary,
                  { flex: 1 }
                )}
              >
                Cancel
              </button>

              <button
                onClick={handleUpgrade}
                disabled={loading}
                style={mergeStyles(
                  buttonStyles.base,
                  loading ? buttonStyles.disabled : buttonStyles.primary,
                  { flex: 1 }
                )}
              >
                {loading ? 'Loading...' : 'Continue to Payment'}
              </button>
            </div>

            <p style={{
              marginTop: spacing.lg,
              fontSize: typography.fontSize.xs,
              color: theme.text.secondary,
              textAlign: 'center'
            }}>
              Secure payment powered by Stripe
            </p>
          </div>
        </div>
      )}
    </>
  );
}